import { isNumber } from '~/components/utils/core/number';

export const NUMBER_INPUT_ALLOWED_KEYS = Object.freeze({
  Backspace: true,
  Delete: true,
  Enter: true,
  Tab: true,
  End: true,
  Home: true,
  ArrowLeft: true,
  ArrowDown: true,
  ArrowRight: true,
  ArrowUp: true,
}) as Record<string, boolean>;

export const FLOAT_INPUT_ALLOWED_KEYS = Object.freeze({
  ...NUMBER_INPUT_ALLOWED_KEYS,
  Period: true,
}) as Record<string, boolean>;

export const validateNumberInput = (event: KeyboardEvent): void => {
  if (!(isNumber(Number(event.key)) || NUMBER_INPUT_ALLOWED_KEYS[event.key])) {
    event.preventDefault();
  }
};

export const validateFloatInput = (event: KeyboardEvent): void => {
  if (!(isNumber(Number(event.key)) || FLOAT_INPUT_ALLOWED_KEYS[event.code])) {
    event.preventDefault();
  }
};
